import { boot } from "@origin-digital/bootloader";
import { configFetch } from "@origin-digital/daxi";
import { initHandler } from "@origin-digital/mesh";
import { initWebChat } from "@origin-digital/origin-chat";
import { initBraze } from "@origin-digital/braze";
import { initGeoTargeting } from "@origin-digital/geo-targeting";
import { EnvironmentNames } from "@origin-digital/platform-enums";
import { isNative as verifyIsNative } from "@origin-digital/platform-helpers";
import {
  configAnalytics,
  configNewRelic,
  INewRelicConfig,
} from "@origin-digital/reporting-client";
import { shouldInitialize } from "./utils";

const environment = window.oetal.env.name as EnvironmentNames;
const isSSR = window.oetal.ssr.onServer;
const {
  allowedScopes = [],
  authenticated = false,
  enableChat,
  enableSurvicate = true,
} = window.oetal.pageData;

const disableAuthCheck = ["local", "dev"].includes(environment);
const isNative = verifyIsNative();

let path = "";
const parameters: Record<string, string> = {};
if (typeof window !== "undefined") {
  path = window.location.pathname;
  if (typeof URLSearchParams !== "undefined") {
    new URLSearchParams(window.location.search).forEach(
      (value, key) => (parameters[key] = value)
    );
  }
}

const stagingNewRelicConfig: Partial<INewRelicConfig> = {
  // NR Ingestion Key for Tal Client Prod Account, not a secret
  apiKey: "76cb225157457a776b398513c9aed3e2FFFFNRAL",
  logLevel: "info",
  consoleLogLevel: "none",
};
const prodNewRelicConfig: Partial<INewRelicConfig> = {
  // NR Ingestion Key for Tal Client Prod Account, not a secret
  apiKey: "20660d24ad1850940e1985959b97c8345b53NRAL",
  logLevel: "warn",
  consoleLogLevel: "none",
};

const appName = window.oetal.apps?.[0]?.name || "tal-client";

const nrConfig =
  environment === "prod" ? prodNewRelicConfig : stagingNewRelicConfig;

// init NewRelic here, to be over-riden by microsites, but setting up defaults
if (environment === "prod" || environment === "staging") {
  configNewRelic({
    ...nrConfig,
    isNative,
    appName,
    endpoint: "https://log-api.newrelic.com/log/v1",
    sourceEnv: environment,
  } as INewRelicConfig);
}

// init mesh here
initHandler({
  isNative,
  environment,
  parameters,
});

configFetch({
  environment: environment as any,
  disableAuthCheck,
});

if (enableChat) {
  initWebChat();
}

initGeoTargeting();

initBraze({
  environment,
  path,
  parameters,
});

configAnalytics({
  debugToConsole: true,
});

if (enableSurvicate && shouldInitialize()) {
  import("@origin-digital/survicate").then((res) =>
    res.initSurvicate(environment)
  );
}

boot({
  isNative,
  authenticated,
  isSSR,
  path,
  parameters,
  environment,
  allowedScopes,
});
